/** Элементы и при необходимости номера экземпляров, закодированные во внутренних ссылках. */
export function linkedElementRefs(html) {
  const refs = new Map();
  const pattern = /<a\b([^>]*)>(.*?)<\/a>/gis;
  let match;
  while ((match = pattern.exec(html || ""))) {
    const href = /href\s*=\s*["']#scheme-node-element-(\d+)(?:-instance-(\d+))?["']/i.exec(match[1]);
    if (!href) continue;
    const id = Number(href[1]);
    const label = new DOMParser().parseFromString(match[2], "text/html").body.textContent.trim();
    const legacyInstance = /-(\d+)$/.exec(label);
    const instance = href[2] ? Number(href[2]) : legacyInstance ? Number(legacyInstance[1]) : null;
    refs.set(`${id}:${instance === null ? "all" : instance}`, { id, instance });
  }
  return [...refs.values()];
}

/** Уникальные ID типов элементов легенды, независимо от числа связанных экземпляров. */
export function linkedElementIds(html) {
  return [...new Set(linkedElementRefs(html).map((ref) => ref.id))];
}

/** Превращает HTML редактора в безопасные текстовые и ссылочные части. */
export function functionalityTextParts(html) {
  const parsed = new DOMParser().parseFromString(html || "", "text/html");
  const parts = [];
  const pushText = (text) => {
    if (text) parts.push({ type: "text", text });
  };
  const visit = (node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      pushText(node.nodeValue);
      return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE) return;

    const tag = node.tagName.toLowerCase();
    if (tag === "a") {
      const match = /^#scheme-node-element-(\d+)(?:-instance-(\d+))?$/.exec(node.getAttribute("href") || "");
      if (match && node.textContent) {
        const legacyInstance = /-(\d+)$/.exec(node.textContent.trim());
        parts.push({
          type: "element",
          id: Number(match[1]),
          instance: match[2] ? Number(match[2]) : legacyInstance ? Number(legacyInstance[1]) : null,
          text: node.textContent,
        });
      } else {
        pushText(node.textContent || "");
      }
      return;
    }
    if (tag === "br") {
      pushText("\n");
      return;
    }

    const block = ["p", "div", "li", "blockquote"].includes(tag);
    Array.from(node.childNodes).forEach(visit);
    if (block && parts.length && !parts[parts.length - 1].text.endsWith("\n")) pushText("\n");
  };

  Array.from(parsed.body.childNodes).forEach(visit);
  if (parts.length && parts[parts.length - 1].text.endsWith("\n")) {
    parts[parts.length - 1].text = parts[parts.length - 1].text.replace(/\n+$/, "");
  }
  return parts.filter((part) => part.text);
}
